import api from "@/config/axios";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import router from "../router";
import store from "@/store";

const URL_API = "portal-privado/auth/";
export const userKey = "userLoggedDirecto";
export default {
  login(rut) {
    let data = {
      usuario: rut
    };
    return api.post(URL_API + "loginDirecto", data);
  },
  setUserLogged(userLogged, start = null) {
    start = start || new Date().getTime();
    let expireTime = new Date(start + userLogged.tokenExp * 1000);
    delete userLogged.imagen_b64;
    let usuarioEncriptado = CryptoJS.AES.encrypt(
      JSON.stringify(userLogged),
      process.env.VUE_APP_CRYPT_KEY
    ).toString();
    Cookies.set(userKey, usuarioEncriptado, {
      expires: expireTime
    });
    Cookies.set(userKey + "Expired", expireTime);
    store.dispatch("close_timeout", true);
    store.dispatch("set_timeout", { direct: true, key: userKey + "Expired" });
  },
  async extenderCookie(min) {
    //Agregar validacion en api
    await this.renovarToken(min)
      .then((res) => {
        let { token, tokenExp } = res.data;
        let usuario = this.getUserLogged();
        Cookies.remove(userKey);
        usuario.token = token;
        usuario.tokenExp = tokenExp;
        let currentExpire = Cookies.get(userKey + "Expired");
        let newExpireTime = new Date(
          new Date(currentExpire).getTime() + min * 60 * 1000
        );
        this.setUserLogged(usuario, newExpireTime);
      })
      .catch((err) => {
        err;
      });
  },

  renovarToken(minutes) {
    return api.post(URL_API + "renewTokenDirecto", { minutes });
  },
  getUserLogged() {
    let usuarioEncriptado = Cookies.get(userKey);
    let usuario = CryptoJS.AES.decrypt(
      usuarioEncriptado,
      process.env.VUE_APP_CRYPT_KEY
    ).toString(CryptoJS.enc.Utf8);
    return JSON.parse(usuario);
  },
  async cerrarSesion(redirect = true) {
    Cookies.remove(userKey + "Expired");
    Cookies.remove(userKey);
    if (redirect) await router.push({ name: "pago-directo", params: {} });
    await store.dispatch("close_timeout", true);
  },
  isAuthenticated() {
    return Cookies.get(userKey) !== undefined;
  },
  isExpireSet() {
    return Cookies.get(userKey + "Expired") !== undefined;
  }
};
